import React from 'react';
import { D, st, toArr, fmt } from '../constants';
import { getDirections } from './shared';

export default function Clients({clients, estimates, invoices, openClientModal, deleteClient, calcTotal}) {
  const [detail, setDetail] = React.useState(null);

  if (detail) {
    const c = detail;
    const cInvs = toArr(invoices).filter(i=>i.clientId===c.id);
    const cEsts = toArr(estimates).filter(e=>e.clientId===c.id);
    const totalPaid = cInvs.filter(i=>i.status==="Paid").reduce((s,i)=>s+calcTotal(i.items),0);
    return (
      <div>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20,flexWrap:"wrap"}}>
          <button style={st.btn()} onClick={()=>setDetail(null)}>← Back</button>
          <h1 style={{...st.h1,margin:0}}>{c.name}</h1>
          {c.address && <button style={st.btn()} onClick={()=>getDirections(c.address)}>Directions</button>}
          <button style={st.btn("primary")} onClick={()=>openClientModal(c)}>Edit</button>
          <button style={st.btn("danger")} onClick={()=>{ deleteClient(c.id); setDetail(null); }}>Delete</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div style={st.card}>
            <div style={st.h2}>Contact info</div>
            {[["Email",c.email],["Phone",c.phone],["Address",c.address]].map(([k,v])=>
              <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${D.border}`}}>
                <span style={{color:D.muted}}>{k}</span><span>{v||"—"}</span>
              </div>
            )}
          </div>
          <div style={st.card}>
            <div style={st.h2}>Summary</div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0"}}>
              <span style={{color:D.muted}}>Total paid</span>
              <span style={{color:D.success,fontWeight:500}}>{fmt(totalPaid)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0"}}>
              <span style={{color:D.muted}}>Estimates</span><span>{cEsts.length}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0"}}>
              <span style={{color:D.muted}}>Invoices</span><span>{cInvs.length}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div style={st.h1}>Clients</div>
        <button style={st.btn("primary")} onClick={()=>openClientModal()}>+ Add Client</button>
      </div>
      <div style={st.card}>
        <div style={{overflowX:"auto"}}><table style={st.table}>
          <thead><tr>{["Name","Email","Phone","Address",""].map(h=><th key={h} style={st.th}>{h}</th>)}</tr></thead>
          <tbody>
            {toArr(clients).map(c=>
              <tr key={c.id} style={{cursor:"pointer"}} onClick={()=>setDetail(c)}>
                <td style={st.td}>
                  <span style={{color:D.accent,fontWeight:500}}>{c.name}</span>
                  {c.referralCount>0 && <span style={{marginLeft:8,fontSize:11,color:D.success}}>⭐ {c.referralCount} referral{c.referralCount>1?'s':''}</span>}
                </td>
                <td style={st.td}>{c.email}</td>
                <td style={st.td}>{c.phone}</td>
                <td style={st.td}>{c.address}</td>
                <td style={st.td} onClick={e=>e.stopPropagation()}>
                  {c.address && <button style={{...st.btn(),fontSize:11,padding:'2px 8px'}} onClick={()=>getDirections(c.address)}>Directions</button>}
                  <button style={st.btn()} onClick={()=>openClientModal(c)}>Edit</button>
                </td>
              </tr>
            )}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
